import React, { useState } from 'react'
import useStore from 'state/knovStore'
import styles from 'components/quests/quest-options.module.scss'
import cn from 'classnames'
import perms from 'lib/perms'
import PermsOptions from 'components/quests/PermsOptions'
import ExtendedOptions from 'components/quests/ExtendedOptions'
import TypeOptions from 'components/quests/TypeOptions'
import { X } from 'lucide-react'

export default function QuestOptions(props) {
    const quest = props.quest
    const amAdmin = perms.amQuestOwner(quest)

    return (
        <React.Fragment>
            <div className={styles.questOptionsComp}>
                <div className={cn(styles.optionsContainer)}>
                    {amAdmin && props.showPermsOptions && (
                        <PermsOptions
                            quest={quest}
                            panel={props.panel}
                            close={props.closeQuestOptions}
                            showHeader={true}
                        />
                    )}

                    {props.showExtendedOptions && (
                        <ExtendedOptions
                            quest={quest}
                            filter={props.filter}
                            deleteHandler={props.deleteQuest}
                            muteQuestUser={props.muteQuestUser}
                            reloadQuest={props.reloadQuest}
                            tweet={props.tweet}
                            close={props.closeQuestOptions}
                        />
                    )}

                    {amAdmin && props.showTypeOptions && (
                        <TypeOptions
                            quest={quest}
                            panel={props.panel}
                            close={props.closeQuestOptions}
                        />
                    )}

                    {props.showFilterDropdown && (
                        <OptionList
                            options={props.answerFilterOptions}
                            selectedValue={props.answerFilter}
                            close={props.closeQuestOptions}
                            showHeader={true}
                            title="Set Message Filter"
                        />
                    )}
                </div>
            </div>
        </React.Fragment>
    )
}

function OptionList(props) {
    //console.log('selectedValue', props.selectedValue)
    const closeQuestOptions = ev => {
        ev.stopPropagation()
        ev.preventDefault()

        if (props.close) props.close()
    }

    return (
        <div className={cn(styles.optionsListComp, props.contextStyles)}>
            {props.showHeader && (
                <div className={styles.questOptionsHeader}>
                    <div className={styles.questOptionsTitle}>{props.title}</div>

                    {props.close && (
                        <div className={styles.questOptionsToggle} onClick={closeQuestOptions}>
                            <X size={16} />
                        </div>
                    )}
                </div>
            )}

            {props.options
                //.filter(opt => props.selectedOption ? opt.value !== props.selectedOption.value : true)
                .map((opt, ix) => {
                    const Comp = opt.customComp ? (
                        opt.customComp
                    ) : (
                        <Option
                            opt={opt}
                            close={props.close}
                            isSelected={opt.value === props.selectedValue}
                        />
                    )
                    return (
                        <div key={ix} className={styles.optionContainer}>
                            {Comp}
                        </div>
                    )
                })}
        </div>
    )
}

function Option(props) {
    const opt = props.opt

    const onClick = async ev => {
        ev.preventDefault()
        ev.stopPropagation()

        const shouldClose = opt.closeOnClick !== false
        if (shouldClose && props.close) props.close()
        if (opt.callback) await opt.callback(opt.value)
    }

    const selectedStyles = props.isSelected ? styles.selected : null
    const isTweeted = opt.value === 'tweeted'

    return (
        <div className={cn(styles.optionComp, selectedStyles)}>
            <div className={styles.optionContainer}>
                <div className={styles.option} onClick={onClick}>
                    {opt.type === 'icon' ? (
                        <span className={cn(styles.optionIcon, isTweeted && styles.tweetedIcon)}>
                            {opt.icon || <i className={opt.logo}></i>}
                        </span>
                    ) : (
                        <span className={styles.optionImage}>
                            <img src={opt.logo} />
                        </span>
                    )}

                    <span className={styles.name}>{opt.name}</span>
                    {opt.desc && <span className={styles.description}>{opt.desc}</span>}
                </div>
            </div>
        </div>
    )
}

export { OptionList, Option }
